import LangEnum from '../../../lang/LangEnum';
import { CriteriaOperatorEnum } from '../enums/criteriaOperator.enum';
import { CatalogCreationFormInput } from './catalogCreationForm.types';

export enum CatalogCreationCriterionEnum {
  AVAILABILITY = 'AVAILABILITY',
  COLLECTION = 'COLLECTION',
  CLASSIFICATION = 'CLASSIFICATION',
}

export type CatalogCreationCriterionValuesFieldName =
  | 'availability'
  | 'collectionIds'
  | 'classificationIds';

export type CatalogCreationCriterionOperatorFieldName =
  | 'availabilityCriteriaOperator'
  | 'classificationCriteriaOperator';

export interface CatalogCreationCriterionConfig {
  criterion: CatalogCreationCriterionEnum;
  typeLabel: LangEnum;
  phraseLabel: LangEnum;
  valuesField: CatalogCreationCriterionValuesFieldName;
  operatorField: CatalogCreationCriterionOperatorFieldName | null;
}

export interface CatalogCreationCriterionOption {
  id: string;
  name: string;
  description?: string;
  groupId?: string;
}

export interface CatalogCreationCriterionOptionLabel {
  name: string;
  description?: string;
  groupId?: string;
}

export type CatalogCreationCriterionOptionLabelsById = Record<
  string,
  CatalogCreationCriterionOptionLabel
>;

export interface CatalogCreationCriterionLabeledValue {
  label: string;
  groupKey: string;
}

export interface CatalogCreationCriterionDraft {
  criterion: CatalogCreationCriterionEnum;
  values: string[];
  operator: CriteriaOperatorEnum;
  optionLabels: CatalogCreationCriterionOptionLabelsById;
}

export interface CatalogCreationCriterionChip {
  criterion: CatalogCreationCriterionEnum;
  phraseLabel: LangEnum;
  values: string[];
  operator: CriteriaOperatorEnum;
}

export interface BuildCatalogCreationCriterionChipsParams {
  values: Pick<CatalogCreationFormInput, CatalogCreationCriterionValuesFieldName>;
  operators: Pick<CatalogCreationFormInput, CatalogCreationCriterionOperatorFieldName>;
}

export interface JoinCatalogCreationCriterionLabelGroupsParams {
  labelGroups: string[][];
  innerOperatorLabel: string;
  outerOperatorLabel: string;
}

export interface BuildCatalogCreationCriterionPhraseParams
  extends JoinCatalogCreationCriterionLabelGroupsParams {
  remainingLabel: string;
}

export interface ToggleCatalogCreationCriterionValueParams {
  values: string[];
  optionId: string;
}

export interface MergeSelectedCatalogCreationCriterionOptionsParams {
  options: CatalogCreationCriterionOption[];
  selectedIds: string[];
  optionLabelsById: CatalogCreationCriterionOptionLabelsById;
}

export interface FilterCatalogCreationCriterionOptionsParams {
  options: CatalogCreationCriterionOption[];
  search: string;
}

export interface CatalogCriterionChange {
  criterion: CatalogCreationCriterionEnum;
  values: string[];
  operator: CriteriaOperatorEnum;
}

export interface UseCatalogCriteriaEditorParams {
  values: Pick<CatalogCreationFormInput, CatalogCreationCriterionValuesFieldName>;
  operators: Pick<CatalogCreationFormInput, CatalogCreationCriterionOperatorFieldName>;
  errorMessage?: string;
  onRegisterOptionLabels: (optionLabels: CatalogCreationCriterionOptionLabelsById) => void;
  onChangeCriterion: (change: CatalogCriterionChange) => void;
}

export interface CatalogCreationCriteriaSourcePickerProps {
  selectedIds: string[];
  optionLabelsById: CatalogCreationCriterionOptionLabelsById;
  operator: CriteriaOperatorEnum | null;
  onBack: () => void;
  onApply: () => void;
  onOperatorChange: (operator: CriteriaOperatorEnum) => void;
  onToggleOption: (option: CatalogCreationCriterionOption) => void;
}
